<template>
    <v-btn id="save-preset-button"
           :disabled="isDisabled"
           name="save-preset-button"
           ref="save-preset-button"
           @click="onClick"
           v-tippy
           content="Save or Import a Preset"
    >
        <v-icon size="24" class="material-symbols-outlined">add_circle</v-icon>
    </v-btn>

</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    mounted() {
        this.$root.$refs.savePresetButton = this.$refs['save-preset-button'];
    },
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image']),
        ...mapState("UI", ["startTips"]),
        isDisabled() {
            return !this.canUsePresets || this.IDT.initial || !this.image || this.blockLoading
        }
    },
    methods: {
        onClick() {
            if (this.isDisabled) return;
            if (window.lutify.isCurrentPlanFree()) {
                window.UI.showModal(window.UI.modals.notAvailableInFree.el);
                return;
            }

            window.UI.modals.presets.save.el.find('input[name="folder"]').hide();
            window.UI.showModal(UI.modals.presets.save.el);
            window.UI.modals.presets.save.el.find('input[type="text"]').val("");
            this.$store.dispatch("UserFiles/fetchPresets");
        }
    }
}
</script>